import {useEffect,useState} from "react";
import {
  Box,
  Button,
  Container,
  Drawer,
  IconButton,
  Stack,
  Typography
} from "@mui/material";
import {
  NorthEastRounded,
  CloseRounded,
  MenuRounded
} from "@mui/icons-material";
import {Link,useLocation} from "react-router-dom";
import {useAppTheme} from "../context/ThemeContext";
import logo from "../static/logo2.webp";

const NAV_ITEMS=[
  {
    label:"Inicio",
    path:"/"
  },
  {
    label:"Partidos",
    path:"/torneos/nexus-cup-2026/calendario"
  }
];

const TOURNAMENT_PATH="/torneos/nexus-cup-2026";

export default function Navbar(){
  const {typography}=useAppTheme();
  const location=useLocation();

  const [open,setOpen]=useState(false);
  const [scrolled,setScrolled]=useState(false);

  useEffect(()=>{
    const updateScroll=()=>{
      setScrolled(window.scrollY>70);
    };

    updateScroll();

    window.addEventListener("scroll",updateScroll,{
      passive:true
    });

    return()=>{
      window.removeEventListener("scroll",updateScroll);
    };
  },[]);

  useEffect(()=>{
    setOpen(false);
  },[location.pathname]);

  const isActive=path=>{
    if(path==="/"){
      return location.pathname==="/";
    }

    return location.pathname===path||
      location.pathname.startsWith(`${path}/`);
  };

  const ctaSx={
    minHeight:scrolled?36:41,
    px:scrolled?2:2.6,
    borderRadius:"999px",
    backgroundColor:"#1647A8",
    color:"#FFFFFF",
    fontSize:typography.sizes.sm,
    fontWeight:600,
    textTransform:"none",
    textDecoration:"none",
    whiteSpace:"nowrap",
    boxShadow:"none",
    transition:"all .3s ease",
    "&:hover":{
      backgroundColor:"#2359C4",
      boxShadow:"none"
    }
  };

  return(
    <>
      <Box
        component="header"
        sx={{
          position:"fixed",
          top:0,
          left:0,
          right:0,
          width:"100%",
          zIndex:1200,
          pointerEvents:"none",
          pt:{
            xs:scrolled?1.25:2,
            sm:scrolled?1.5:2.5,
            md:scrolled?1.5:3
          },
          transition:"padding .3s ease"
        }}
      >
        <Container
          maxWidth="xl"
          sx={{
            px:{xs:1.5,sm:3,md:4,lg:5},
            display:"flex",
            justifyContent:"center"
          }}
        >
          <Box
            sx={{
              width:"100%",
              maxWidth:scrolled?1080:1230,
              minHeight:{
                xs:scrolled?54:62,
                sm:scrolled?56:66,
                md:scrolled?58:74
              },
              px:{
                xs:scrolled?1.5:2,
                sm:scrolled?2:2.5,
                md:scrolled?2.5:3.5
              },
              display:"flex",
              alignItems:"center",
              justifyContent:"space-between",
              gap:{xs:1,md:3},
              borderRadius:"999px",
              border:scrolled
                ?"1px solid rgba(190,209,245,.20)"
                :"1px solid rgba(190,209,245,.17)",
              backgroundColor:scrolled
                ?"rgba(5,17,43,.83)"
                :"rgba(5,17,43,.96)",
              backdropFilter:"blur(18px) saturate(135%)",
              WebkitBackdropFilter:"blur(18px) saturate(135%)",
              boxShadow:"none",
              pointerEvents:"auto",
              transition:[
                "max-width .35s ease",
                "min-height .35s ease",
                "padding .35s ease",
                "background-color .35s ease",
                "border-color .35s ease"
              ].join(",")
            }}
          >
            <Box
              component={Link}
              to="/"
              aria-label="Ir al inicio de TORNEOS"
              sx={{
                display:"inline-flex",
                alignItems:"center",
                justifyContent:"center",
                flexShrink:0,
                minWidth:0,
                textDecoration:"none"
              }}
            >
              <Box
                component="img"
                src={logo}
                alt="TORNEOS"
                sx={{
                  display:"block",
                  width:"auto",
                  height:{
                    xs:scrolled?34:41,
                    sm:scrolled?37:45,
                    md:scrolled?39:51
                  },
                  maxWidth:{xs:145,sm:170,md:195},
                  objectFit:"contain",
                  transition:"height .35s ease"
                }}
              />
            </Box>

            <Stack
              direction="row"
              alignItems="center"
              spacing={0.5}
              sx={{
                display:{xs:"none",md:"flex"},
                ml:"auto",
                px:1,
                borderRadius:"999px",
                backgroundColor:"rgba(255,255,255,.045)",
                border:"1px solid rgba(255,255,255,.07)"
              }}
            >
              {NAV_ITEMS.map(item=>{
                const active=isActive(item.path);

                return(
                  <Box
                    key={item.path}
                    component={Link}
                    to={item.path}
                    aria-current={active?"page":undefined}
                    sx={{
                      display:"inline-flex",
                      alignItems:"center",
                      justifyContent:"center",
                      minHeight:scrolled?36:41,
                      px:2.5,
                      borderRadius:"999px",
                      textDecoration:"none",
                      color:active
                        ?"#FFFFFF"
                        :"rgba(235,242,255,.72)",
                      backgroundColor:active
                        ?"rgba(255,255,255,.13)"
                        :"transparent",
                      fontSize:typography.sizes.sm,
                      fontWeight:active?600:500,
                      whiteSpace:"nowrap",
                      transition:"all .25s ease",
                      "&:hover":{
                        color:"#FFFFFF",
                        backgroundColor:"rgba(255,255,255,.10)"
                      }
                    }}
                  >
                    {item.label}
                  </Box>
                );
              })}
            </Stack>

            <IconButton
              aria-label="Abrir menú"
              aria-expanded={open}
              aria-controls={open?"torneos-menu-movil":undefined}
              onClick={()=>setOpen(true)}
              sx={{
                display:{xs:"inline-flex",md:"none"},
                width:scrolled?38:42,
                height:scrolled?38:42,
                flexShrink:0,
                color:"#FFFFFF",
                backgroundColor:"rgba(255,255,255,.08)",
                border:"1px solid rgba(255,255,255,.12)",
                transition:"all .3s ease",
                "&:hover":{
                  backgroundColor:"rgba(255,255,255,.15)"
                }
              }}
            >
              <MenuRounded fontSize="small"/>
            </IconButton>
          </Box>
        </Container>
      </Box>

      <Drawer
        anchor="right"
        open={open}
        onClose={()=>setOpen(false)}
        ModalProps={{
          keepMounted:true
        }}
        PaperProps={{
          id:"torneos-menu-movil",
          sx:{
            width:{xs:"min(86vw,320px)",sm:340},
            maxWidth:"100%",
            backgroundColor:"#06132D",
            color:"#FFFFFF",
            borderLeft:"1px solid rgba(255,255,255,.12)",
            boxShadow:"none"
          }
        }}
      >
        <Box
          sx={{
            minHeight:"100%",
            display:"flex",
            flexDirection:"column"
          }}
        >
          <Box
            sx={{
              px:2.5,
              py:2.5,
              display:"flex",
              alignItems:"center",
              justifyContent:"space-between",
              borderBottom:"1px solid rgba(255,255,255,.10)"
            }}
          >
            <Box
              component="img"
              src={logo}
              alt="TORNEOS"
              sx={{
                width:"auto",
                height:46,
                maxWidth:185,
                objectFit:"contain"
              }}
            />

            <IconButton
              aria-label="Cerrar menú"
              onClick={()=>setOpen(false)}
              sx={{
                width:38,
                height:38,
                color:"#FFFFFF",
                border:"1px solid rgba(255,255,255,.12)",
                "&:hover":{
                  backgroundColor:"rgba(255,255,255,.10)"
                }
              }}
            >
              <CloseRounded fontSize="small"/>
            </IconButton>
          </Box>

          <Stack
            spacing={1.25}
            sx={{
              px:2.5,
              pt:4
            }}
          >
            {NAV_ITEMS.map(item=>{
              const active=isActive(item.path);

              return(
                <Box
                  key={item.path}
                  component={Link}
                  to={item.path}
                  onClick={()=>setOpen(false)}
                  aria-current={active?"page":undefined}
                  sx={{
                    minHeight:48,
                    px:2.5,
                    display:"flex",
                    alignItems:"center",
                    borderRadius:"999px",
                    color:active
                      ?"#FFFFFF"
                      :"rgba(235,242,255,.78)",
                    backgroundColor:active
                      ?"rgba(255,255,255,.12)"
                      :"transparent",
                    fontSize:typography.sizes.sm,
                    fontWeight:active?600:500,
                    textDecoration:"none",
                    transition:"background-color .2s ease",
                    "&:hover":{
                      backgroundColor:"rgba(255,255,255,.09)"
                    }
                  }}
                >
                  {item.label}
                </Box>
              );
            })}

          </Stack>

          <Box
            sx={{
              mt:"auto",
              px:3,
              pb:3
            }}
          >
            <Typography
              sx={{
                pt:2,
                borderTop:"1px solid rgba(255,255,255,.12)",
                fontSize:typography.sizes.xs,
                fontWeight:400,
                lineHeight:1.7,
                color:"rgba(235,242,255,.60)",
                textAlign:"center"
              }}
            >
              Plataforma de torneos deportivos
            </Typography>
          </Box>
        </Box>
      </Drawer>
    </>
  );
}